<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    nudge-right="40"
    nudge-top="30"
    transition="scale-transition"
    offset-y
    min-width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateMain"
        :label="itemAction.name"
        @click:clear="clearData()"
        prepend-inner-icon="mdi-calendar"
        v-bind="attrs"
        v-on="on"
        clearable
        readonly
        dense
        outlined>
      </v-text-field>
    </template>

    <v-date-picker
      v-model="dateMain"
      type="month"
      show-adjacent-months
      @change="save"
      min="1940-01-01"
      year-icon="mdi-calendar-blank"
      prev-icon="mdi-skip-previous"
      next-icon="mdi-skip-next"
      locale="es">
    </v-date-picker>

  </v-menu>
</template>

<script>
import { DatesUtils } from '@/mixins/datesUtilsMixin'
export default {
  mixins: [DatesUtils],
  props: ['itemAction', 'setterModel', 'onSuccess'],
  data: () => ({
    dateMain: '',
    menu: false
  }),
  mounted () {
    this.seterModel(this.setterModel)
  },
  methods: {
    save (date) {
      this.$refs.menu.save(date)
      if (date != null) this.onSuccess({ id: this.itemAction.nameid, data: date })
    },
    clearData () {
      this.dateMain = ''
      this.onSuccess({ id: this.itemAction.nameid, data: null })
    },
    setDefault () {
      const date = new Date()
      const fecha = this.formatoFecha(date, 'yyyy-mm')
      this.dateMain = fecha
      this.onSuccess({ id: this.itemAction.nameid, data: fecha })
    },
    seterModel (val) {
      if (val) this.dateMain = val
      else if (this.itemAction.default) this.setDefault()
    }
  },
  watch: {
    setterModel (val) {
      if (val) this.dateMain = val
    }
  }
}
</script>

<style>
</style>
